<div *nzModalTitle>
  <div class="modal-title" *ngIf="!isSuccess && !isInviteStep">Добавление контакта</div>
  <!--<div class="modal-title" *ngIf="!isSuccess && isInviteStep">Отправить приглашение</div>-->
  <div class="modal-title" *ngIf="isSuccessInvite">Приглашение отправлено</div>
  <div class="modal-title" *ngIf="isCreateChat">Чат создан</div>
</div>
<div class="modal">
  <div class="modal__body">
    <div class="success" *ngIf="!isSuccess && isInviteStep">
      <p class="send">Контакт с номером {{phone}} не зарегистрирован в системе. Отправить приглашение на этот номер?</p> <!--Для отправки приглашения необходимо укажите Email контакта-->
    </div>
    <form autocomplete="off" (submit)="submit()" *ngIf="!isSuccess">
      <div class="field-list">
        <div class="field" *ngIf="!isSuccess && !isInviteStep">
          <div class="caption">Телефон</div>
          <div class="field-input">
            <ui-input-phone placeholder="Телефон" [formControl]="userPhone"></ui-input-phone>
          </div>
        </div>
        <!--<div class="field" *ngIf="!isSuccess && isInviteStep">
          <div class="caption">Email</div>
          <div class="field-input">
            <ui-input-email placeholder="Email" [formControl]="userEmail"></ui-input-email>
          </div>
        </div>-->
      </div>
    </form>
    <div class="success" *ngIf="isSuccess">
      <p *ngIf="isSuccessInvite">На Номер {{phone}} отправлено приглашение в систему.</p>
      <p *ngIf="isCreateChat">Контакт с номером {{phone}} успешно добавлен в ваш список контактов.</p>
    </div>
    <div class="error" *ngIf="serverError && !isSuccess">
      {{serverError}}
    </div>
  </div>

  <div class="modal__footer">
    <ui-button *ngIf="!isSuccess && !isInviteStep" (click)="destroyModal()">{{cancelTextBtn}}</ui-button>
    <ui-button *ngIf="!isSuccess && !isInviteStep" [ngClass]="{'disabled': userPhone.invalid}" (click)="userPhone.valid && submit()" >{{confirmTextBtn}}</ui-button>
    <ui-button *ngIf="isSuccess" (click)="confirmModal()">Понятно</ui-button>
    <ui-button *ngIf="!isSuccess && isInviteStep" [ngClass]="{'disabled': userPhone.invalid}" (click)="userPhone.valid && inviteChat()">Отправить</ui-button>
  </div>
</div>
